<template>
  <b-dropdown
    size="sm"
    variant="link"
    no-caret
    toggle-class="p-0"
    menu-class="event-template-dropdown">
    <template #button-content>
      <b-button
        variant="primary"
        class="toggle-button"
        size="sm">
        {{ selectedOption ? selectedOption.text : text }}
      </b-button>
    </template>
    <b-dropdown-item-button
      v-for="option in options"
      :key="option.value"
      :value="option"
      :active="option.value === _value"
      button-class="d-flex"
      @click="onSelect(option.value)">
      <div
        class="template-color mr-2"
        :style="`background-color: ${option.color};`" />
      <div
        v-if="option.categoryName"
        class="category-name">
        {{ option.categoryName }}
      </div>
      <div class="template-text">
        {{ option.text }}
      </div>
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    selectedOption() {
      return this.options.find(option => option.value === this._value)
    }
  },
  methods: {
    onSelect(v) {
      this._value = v
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-button {
  height: 24px;
  padding: 4px;
  min-width: 80px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.template-color {
  width: 15px;
  min-width: 15px;
  height: 24px;
  border: 1px solid $grey02;
}

.category-name {
  font-size: $fs-s;
  padding: 1px 5px;
  background-color: $grey03;
  margin-right: 8px;
  align-self: center;
}

.template-text {
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
.event-template-dropdown {
  max-height: 400px;
  overflow-y: scroll;
  max-width: calc(100vw - 90px);
}
</style>